import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Landingpage    from './pages/Landingpage';
import Projects       from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';

/**
 * Scrolls to the top of the page on every route change.
 * If a hash is present in the URL (e.g. #contact), scrolls to that
 * element instead — allowing deep links like /projects/:id#contact to work.
 */
function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            // Wait for the page to render before scrolling to the element
            setTimeout(() => {
                const el = document.querySelector(hash);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        } else {
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        }
    }, [pathname, hash]);

    return null;
}

function App() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/"             element={<Landingpage />}    />
                <Route path="/projects"     element={<Projects />}        />
                <Route path="/projects/:id" element={<ProjectDetails />}  />
            </Routes>
        </Router>
    );
}

export default App;